(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evidence-stats-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Intersection Observer for fade-in
  var grids = document.querySelectorAll('.evidence-bar__stats');
  if (!grids.length) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animateCounters(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    grids.forEach(function(grid) { observer.observe(grid); });
  } else {
    // Fallback
    grids.forEach(function(grid) {
      grid.classList.add('is-visible');
      animateCounters(grid);
    });
  }

  function animateCounters(container) {
    var counters = container.querySelectorAll('[data-count-target]');
    counters.forEach(function(el) {
      var raw = el.getAttribute('data-count-target');
      var parsed = parseCountTarget(raw);
      if (!parsed) return;

      var duration = 1600;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        // Ease out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(parsed.number * eased);
        el.textContent = parsed.prefix + formatNumber(current, parsed.hasCommas) + parsed.suffix;
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    });
  }

  function parseCountTarget(str) {
    // Match patterns like "45,708", "79%", "13x", "£2.5M", "100+"
    var match = str.match(/^([^0-9]*?)([\d,]+(?:\.\d+)?)(.*)$/);
    if (!match) return null;
    var prefix = match[1];
    var numStr = match[2];
    var suffix = match[3];
    var hasCommas = numStr.indexOf(',') !== -1;
    var number = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(number)) return null;
    return { prefix: prefix, number: number, suffix: suffix, hasCommas: hasCommas };
  }

  function formatNumber(num, withCommas) {
    if (!withCommas) return num.toString();
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-search"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.smart-search');
    if (!section) return;
    
    var form = document.getElementById('smart-search-form');
    var input = document.getElementById('smart-search-input');
    var tags = section.querySelectorAll('.smart-search__tag');
    
    // Convert separators to OR logic on form submit
    if (form && input) {
      form.addEventListener('submit', function(e) {
        var query = input.value.trim();
        
        // Check if query contains separators (/, |, or comma)
        if (query.indexOf('/') > -1 || query.indexOf('|') > -1 || query.indexOf(',') > -1) {
          e.preventDefault();
          
          // Split by separators and clean up
          var terms = query.split(/[\/\|,]/)
            .map(function(term) { return term.trim(); })
            .filter(function(term) { return term.length > 0; });
          
          if (terms.length > 0) {
            // Join with OR operator
            input.value = terms.join(' OR ');
            form.submit();
          }
        }
        // Otherwise let form submit normally
      });
    }
    
    // Handle suggestion tag clicks
    tags.forEach(function(tag) {
      tag.addEventListener('click', function(e) {
        if (input && !e.metaKey && !e.ctrlKey) {
          e.preventDefault();
          var searchTerm = new URL(this.href).searchParams.get('q');
          
          // Check if search term has separators, convert to OR
          if (searchTerm.indexOf('/') > -1 || searchTerm.indexOf('|') > -1 || searchTerm.indexOf(',') > -1) {
            var terms = searchTerm.split(/[\/\|,]/)
              .map(function(term) { return term.trim(); })
              .filter(function(term) { return term.length > 0; });
            input.value = terms.join(' OR ');
          } else {
            input.value = searchTerm;
          }
          
          form.submit();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
